
const ModifyCategory = (mcId) => {
  return (
    <div>
      <h1>Update Category</h1>
    </div>
  );
}

export default ModifyCategory;